import React, { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

type UserRole = 'student' | 'teacher' | 'schoolAdmin' | 'superAdmin';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !currentUser) {
      navigate('/login');
    }
  }, [currentUser, loading, navigate]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div
          style={{
            width: 40,
            height: 40,
            border: '3px solid var(--Color-line-normal, #F0F0F0)',
            borderTopColor: 'var(--Color-fill-brand-color, #FF6F0F)',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}
        />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: { pathname: location.pathname } }} replace />;
  }

  // /class/main 페이지에서 로그인된 경우 역할에 따라 리다이렉트
  if (location.pathname === '/class/main' && currentUser) {
    const previousPath = location.state?.from?.pathname;
    if (!previousPath?.startsWith('/makecodearcade')) {
      if (['teacher', 'schoolAdmin', 'superAdmin'].includes(currentUser.role)) {
        return <Navigate to="/class/teacher" replace />;
      } else if (currentUser.role === 'student') {
        return <Navigate to="/class/student" replace />;
      }
    }
  }

  if (allowedRoles && !allowedRoles.includes(currentUser.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 